import React from "react";
import "./Skeleton.css";

export const Skeleton = ({ width = "100%", height = "20px", borderRadius = "4px", className = "" }) => (
  <div 
    className={`skeleton ${className}`}
    style={{ width, height, borderRadius }}
  />
);

export const SkeletonCard = () => (
  <div className="skeleton-card">
    <Skeleton height="200px" borderRadius="12px" className="skeleton-card-image" />
    <div className="skeleton-card-content">
      <Skeleton height="24px" width="70%" />
      <Skeleton height="16px" width="90%" className="skeleton-mt-8" />
      <Skeleton height="16px" width="80%" className="skeleton-mt-8" />
      <Skeleton height="40px" width="120px" borderRadius="8px" className="skeleton-mt-16" />
    </div>
  </div>
);

export const SkeletonProfile = () => (
  <div className="skeleton-profile">
    <Skeleton height="100px" width="100px" borderRadius="50%" className="skeleton-profile-pic" />
    <div className="skeleton-profile-info">
      <Skeleton height="24px" width="200px" />
      <Skeleton height="16px" width="150px" className="skeleton-mt-8" />
    </div>
  </div>
);

export const SkeletonList = ({ count = 3 }) => (
  <div className="skeleton-list">
    {Array.from({ length: count }).map((_, index) => (
      <div key={index} className="skeleton-list-item">
        <Skeleton height="60px" borderRadius="8px" />
      </div>
    ))}
  </div>
);

export const SkeletonText = ({ lines = 3 }) => (
  <div className="skeleton-text">
    {Array.from({ length: lines }).map((_, index) => (
      <Skeleton 
        key={index} 
        height="16px" 
        width={index === lines - 1 ? "60%" : "100%"} 
        className={index > 0 ? "skeleton-mt-8" : ""}
      />
    ))}
  </div>
);

export const SkeletonDashboard = () => (
  <div className="skeleton-dashboard">
    <div className="skeleton-dashboard-cards">
      <SkeletonCard />
      <SkeletonCard />
    </div>
  </div>
);

export const SkeletonLobby = () => (
  <div className="skeleton-lobby">
    <div className="skeleton-lobby-header">
      <Skeleton height="40px" width="300px" />
      <Skeleton height="20px" width="200px" className="skeleton-mt-8" />
    </div>
    <div className="skeleton-lobby-content">
      <SkeletonList count={4} />
    </div>
  </div>
);

export const SkeletonSession = () => (
  <div className="skeleton-session">
    <Skeleton height="30px" width="250px" className="skeleton-mb-16" />
    <div className="skeleton-session-grid">
      <Skeleton height="120px" borderRadius="8px" />
      <Skeleton height="120px" borderRadius="8px" />
      <Skeleton height="120px" borderRadius="8px" />
    </div>
  </div>
);

export const SkeletonRoom = () => (
  <div className="skeleton-room">
    <div className="skeleton-room-video">
      <Skeleton height="400px" borderRadius="12px" />
    </div>
    <div className="skeleton-room-controls">
      <Skeleton height="48px" width="48px" borderRadius="50%" />
      <Skeleton height="48px" width="48px" borderRadius="50%" />
      <Skeleton height="48px" width="48px" borderRadius="50%" />
    </div>
  </div>
);

export const SkeletonSearching = () => (
  <div className="skeleton-searching">
    <Skeleton height="100px" width="100px" borderRadius="50%" className="skeleton-searching-icon" />
    <Skeleton height="32px" width="250px" className="skeleton-mt-16" />
    <Skeleton height="20px" width="350px" className="skeleton-mt-8" />
    <div className="skeleton-factoid">
      <Skeleton height="24px" width="200px" className="skeleton-mt-16" />
      <Skeleton height="16px" width="100%" className="skeleton-mt-8" />
      <Skeleton height="16px" width="90%" className="skeleton-mt-8" />
    </div>
  </div>
);

export default Skeleton;
